var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgThumbUpFill = function SvgThumbUpFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 8q.8 0 1.4.6T23 10v2a2 2 0 0 1-.15.75l-3 7.05q-.225.5-.75.85T18 21h-8q-.825 0-1.412-.587A1.93 1.93 0 0 1 8 19V8.825q0-.4.162-.762.164-.363.438-.638l5.425-5.4q.375-.35.887-.425.513-.075.988.175.476.25.687.7.213.45.088.925L15.55 8zM4 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 19v-9q0-.825.587-1.412A1.93 1.93 0 0 1 4 8q.824 0 1.412.588Q6 9.175 6 10v9q0 .824-.588 1.413A1.93 1.93 0 0 1 4 21"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgThumbUpFill);
export { ForwardRef as ReactComponent };